import { Auth0Provider } from "@auth0/auth0-react";
import { ThemeProvider } from "@mui/material/styles";
import PropTypes from "prop-types";

import { SidebarProvider } from "@/contexts/SidebarContext";
import { UpdateDataProvider } from "@/contexts/UpdateDataContext";
import seiuTheme from "@/themes/seiuTheme";

const AppProviders = ({ children }) => {
  return (
    <Auth0Provider
      domain={import.meta.env.VITE_AUTH0_DOMAIN}
      clientId={import.meta.env.VITE_AUTH0_CLIENT_ID}
      audience="https://seiu-fdi.backend.com"
      redirectUri={window.location.origin}
    >
      <UpdateDataProvider>
        <SidebarProvider>
          <ThemeProvider theme={seiuTheme}>{children}</ThemeProvider>
        </SidebarProvider>
      </UpdateDataProvider>
    </Auth0Provider>
  );
};

AppProviders.propTypes = {
  children: PropTypes.element,
};

export default AppProviders;
